import type {ExtraInfo} from './types';

const DATA: ExtraInfo = {
  surveyUrl: '',
  checkInCode: '4565',
  details: [
    {
      type: 'description',
      heading: 'Event Overview',
      paragraphs: [
        {
          content:
            'How do you pivot into tech without a computer science degree—or any coding background at all? What if you’re navigating career burnout, layoffs, or cross-cultural transitions in unfamiliar places? And how do you build confidence when you don’t quite “fit the mold”?',
        },
        {
          content:
            'Join us for an inspiring conversation with Simona, a former Meta employee and journalism major who taught herself data engineering and landed a tech role in Japan—without formal training or Japanese language skills. She’ll share her career journey across the U.S., Singapore, and Japan, including how she overcame setbacks and embraced uncertainty to find her path in tech.',
        },
        {
          content:
            'Beyond her professional story, Simona is a passionate advocate for women in tech, mentoring others and leading nonprofit initiatives that empower underrepresented communities around the world.',
        },
        {
          content:
            "Whether you're exploring tech careers in Japan, aiming to work globally, or transitioning from a non-technical background, this session will offer honest insights, cross-cultural perspectives, and actionable advice. Students and professionals at all levels are welcome!",
        },
      ],
    },
    {type: 'registration-form'},
    {
      type: 'list',
      heading: 'Who is this for',
      items: [
        'Career changers exploring tech from non-traditional paths',
        'Women interested in real-life stories of navigating and thriving in tech',
        'Individuals exploring how culture, identity, and resilience shape careers',
        'Students and professionals seeking mentorship opportunities',
        'Mentors, community builders, and lifelong learners who value diverse experiences in tech',
      ],
    },
    {
      type: 'description',
      heading: 'Guest and Topic Introduction',
      paragraphs: [
        {
          heading: 'Simona Dai, Data Engineer & Community Builder',
          content:
            'Simona is a data engineer with a strong interest in building systems that turn complex data into practical insight. With experience in analytics consulting at Deloitte and data engineering at Meta, she brings a thoughtful and adaptable approach to solving data challenges.',
        },
        {
          content:
            'Originally trained in journalism, Simona transitioned into tech by teaching herself data analytics and engineering through online courses and hands-on projects. This unconventional path fuels her core belief: if she could do it without a traditional technical background, others can too. She is especially passionate about making data and tech more accessible to those from non-traditional or underrepresented backgrounds.',
        },
        {
          content:
            'Her career and community work span the U.S., Singapore, and Japan, where she has combined curiosity, cultural adaptability, and a self-driven learning mindset to grow both personally and professionally.',
        },
        {
          content:
            'Outside of her engineering role, Simona co-leads WomenOverseas, a global nonprofit supporting over 20,000 Chinese-speaking women and non-binary individuals living abroad. She actively mentors others and is committed to helping people grow into their potential—wherever they begin.',
        },
        {
          heading: 'Topic: YouTube University Got Me into FAANG',
          content:
            'Tech isn’t just for computer science majors. With a background in journalism and no formal training, Simona taught herself data analytics through YouTube and worked her way into a data engineering role at Meta.',
        },
        {
          content:
            'Her journey has taken her across the U.S., Singapore, and now Japan—each move bringing a new language, culture, and set of professional challenges. Navigating these transitions has taught her how to learn on the fly, embrace uncertainty, and keep growing.',
        },
        {
          content:
            'In this talk, she’ll share how she made a major career pivot without a CS degree, how she overcame imposter syndrome, and why she believes more people from non-technical paths can—and should—thrive in tech.',
        },
      ],
    },
    {
      type: 'schedule',
      heading: 'Timetable',
      items: [
        {
          timeUTC: 1749861900,
          description: 'Online meeting room opens & check-in',
        },
        {
          timeUTC: 1749862800,
          description: 'Opening',
        },
        {
          timeUTC: 1749863100,
          description: 'Career Story: YouTube University Got Me into FAANG',
          info: ['Simona Dai, Data Engineer & Community Builder'],
        },
        {
          timeUTC: 1749864900,
          description: 'Q&A',
        },
        {
          timeUTC: 1749865800,
          description: 'Closing & Feedback',
        },
        {
          timeUTC: 1749866400,
          description: 'Event end',
        },
      ],
    },
    {
      type: 'description',
      heading: 'Important Information',
      paragraphs: [
        {
          content:
            'Application: The event is free to attend. Once your registration is confirmed, you will receive a calendar invitation. Please sign up by Thursday, June 12, 2025.',
        },
        {
          content:
            "Language: The event will primarily be conducted in English. However, you're welcome to ask questions in both English and Japanese.",
        },
        {
          content:
            'Video Participation: To foster a warm and engaging atmosphere, we kindly ask all participants to keep their cameras on during the session.',
        },
        {
          content:
            'Photography & Recording: Screenshots and recordings may be taken during the online event for promotional purposes (e.g., social media, future event materials). By registering, you consent to using these materials unless you inform us otherwise.',
        },
        {
          content:
            'Schedule: Please note that the event schedule is subject to change on the day of the event.',
        },
        {
          content:
            'Contact: For any event-related inquiries, please contact alliz via email at event@alliz.jp.',
        },
      ],
    },
    {
      type: 'description',
      heading: 'About Host',
      paragraphs: [
        {
          content:
            'alliz is a career mentorship community led by its members, dedicated to career design and development in Japan. We foster mentorship and meaningful connections through community-driven activities, bringing together students, early-career professionals, and mentors from tech-related industries. By sharing experiences, insights, and guidance, we promote mutual growth and learning.',
        },
      ],
    },
  ],
  tags: [],
  thumbnailURL:
    '/static/images/kMASOkQt47/A0S3qmXozWc556HDRUnTzGxNVogo0d9D.png',
};

export default DATA;
